
import menu_back from "../assets/menu_back.jpg";
import "../styles/Contact.css";
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { red } from "@material-ui/core/colors";
import userEvent from "@testing-library/user-event";


function Contact() {

  const form = useRef();
  const nameref = useRef(null);
  const emailref = useRef(null);
  const messageref = useRef(null);
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_imep688', 'template_u275hio', form.current, 'bNJSxFuQCY0U3WFkd')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });

    nameref.current.value = '';
    emailref.current.value = '';
    messageref.current.value = '';
  };
  return (
    <div className="contact">
      <div
        className="leftSide"
        style={{ backgroundImage: `url(${menu_back})` }}
      ></div>
      <div className="rightSide">
        <h1 style={{ color: red }}> Contact Us</h1>

        <form id="contact-form" ref={form} onSubmit={sendEmail}>
          <label htmlFor="user_name">Name</label>
          <input ref={nameref} name="user_name" placeholder="Enter full name..." type="text" />
          <label htmlFor="user_email">Email</label>
          <input ref={emailref} name="user_email" placeholder="Enter email..." type="email" />
          <label htmlFor="message">Message</label>
          <textarea ref={messageref}
            rows="6"
            placeholder="Enter message..."
            name="message"
            required
          ></textarea>
          <button type="submit" value="Send" onClick={() => alert("Message send")} > Send Message</button>
        </form>
      </div>
    </div>
  );
}

export default Contact;